var ja = {
	"neptune.Button.loadingAriaLabel": "読み込み中…",
	"neptune.Chips.ariaLabel": "{choice}を消去する",
	"neptune.ClearButton.ariaLabel": "消去する",
	"neptune.CloseButton.ariaLabel": "閉じる",
	"neptune.DateInput.day.label": "日",
	"neptune.DateInput.day.placeholder": "日",
	"neptune.DateInput.month.label": "月",
	"neptune.DateInput.year.label": "年",
	"neptune.DateInput.year.placeholder": "年（西暦）",
	"neptune.DateLookup.day": "日",
	"neptune.DateLookup.goTo20YearView": "20年表示に移動する",
	"neptune.DateLookup.month": "月",
	"neptune.DateLookup.next": "次",
	"neptune.DateLookup.previous": "前",
	"neptune.DateLookup.selected": "選択済み",
	"neptune.DateLookup.twentyYears": "20年",
	"neptune.DateLookup.year": "年",
	"neptune.FlowNavigation.back": "前のステップに戻る",
	"neptune.Info.ariaLabel": "詳細",
	"neptune.Label.optional": "（任意）",
	"neptune.Link.opensInNewTab": "（新しいタブで開きます）",
	"neptune.MoneyInput.Select.placeholder": "選択してください...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "通貨を選択してください",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "選択してください…",
	"neptune.Select.searchPlaceholder": "検索する... ",
	"neptune.SelectInput.noResultsFound": "結果が見つかりませんでした",
	"neptune.SelectOption.action.label": "選択してください",
	"neptune.SelectOption.selected.action.label": "選択したオプションを変更する",
	"neptune.StatusIcon.iconLabel.error": "エラー：",
	"neptune.StatusIcon.iconLabel.information": "情報：",
	"neptune.StatusIcon.iconLabel.pending": "保留中：",
	"neptune.StatusIcon.iconLabel.success": "完了：",
	"neptune.StatusIcon.iconLabel.warning": "警告：",
	"neptune.Summary.statusDone": "完了",
	"neptune.Summary.statusNotDone": "未完了",
	"neptune.Summary.statusPending": "保留中",
	"neptune.Table.actionHeader": "アクション",
	"neptune.Table.emptyData": "結果が見つかりませんでした",
	"neptune.Table.loaded": "テーブルデータが読み込まれました",
	"neptune.Table.loading": "テーブルデータを読み込み中です",
	"neptune.Table.refreshPage": "ページを更新する",
	"neptune.Upload.csButtonText": "別のファイルをアップロードしますか？",
	"neptune.Upload.csFailureText": "アップロードに失敗しました。もう一度やり直してください。",
	"neptune.Upload.csSuccessText": "アップロードが完了しました。",
	"neptune.Upload.csTooLargeMessage": "{maxSize}MB以下のファイルをアップロードしてください",
	"neptune.Upload.csWrongTypeMessage": "ファイルの種類はサポートされていません。別のファイルで再度お試しください",
	"neptune.Upload.psButtonText": "キャンセルする",
	"neptune.Upload.psProcessingText": "アップロードしています…",
	"neptune.Upload.retry": "やり直す",
	"neptune.Upload.usButtonText": "またはファイルを選択する",
	"neptune.Upload.usDropMessage": "ファイルをドロップしてアップロードする",
	"neptune.Upload.usPlaceholder": "{maxSize}MB以下のファイルをドラッグ＆ドロップしてください",
	"neptune.UploadButton.allFileTypes": "すべてのファイル種類",
	"neptune.UploadButton.dropFiles": "ファイルをドロップしてアップロードする",
	"neptune.UploadButton.instructions": "{fileTypes}、{size}MB以下",
	"neptune.UploadButton.maximumFiles": "最大ファイル数：{maxFiles}個",
	"neptune.UploadButton.uploadFile": "ファイルをアップロードする",
	"neptune.UploadButton.uploadFiles": "ファイルをアップロードする",
	"neptune.UploadInput.deleteModalBody": "このファイルを削除すると、当社のシステムからも削除されます。",
	"neptune.UploadInput.deleteModalCancelButtonText": "キャンセルする",
	"neptune.UploadInput.deleteModalConfirmButtonText": "削除する",
	"neptune.UploadInput.deleteModalTitle": "このファイルを削除しますか？",
	"neptune.UploadInput.fileIsTooLarge": "ファイルが大きすぎます。",
	"neptune.UploadInput.fileTypeNotSupported": "このファイルの種類はサポートされていません",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "申し訳ございませんが、このアップロードに失敗しました。一度に{maxFilesAllowed}個のファイルのみ受付可能です。",
	"neptune.UploadItem.deleting": "削除しています...",
	"neptune.UploadItem.removeFile": "{filename}のファイルを削除する",
	"neptune.UploadItem.uploaded": "アップロード済み",
	"neptune.UploadItem.uploadedFile": "アップロード済みのファイル",
	"neptune.UploadItem.uploading": "アップロードしています…",
	"neptune.UploadItem.uploadingFailed": "アップロードに失敗しました"
};

export { ja as default };
//# sourceMappingURL=ja.json.mjs.map
